<div class='choose-payment-wrapper'>
  <div class="choose-payment-subheader">
    <span class='subheader-title'>{{ "APP.BOOKING_SLOTS.PARTICIPANTS.HOW_SHOULD_PARTICIPANTS_ENTER" | translate }}</span>
    <span class='description'>{{ "APP.BOOKING_SLOTS.PARTICIPANTS.SELECT_THE_BEST_OPTION" | translate }}</span>
  </div>
  <mat-radio-group
    class="payment-radio-group"
    [disabled]="paymentTypes.length === 0"
    [(ngModel)]="chosenPayment"
    (ngModelChange)="choosePayment($event)"
  >
    @for (paymentType of paymentTypes; track paymentType) {
      <mat-radio-button
        class="payment-radio-button"
        [value]="paymentType"
        [disabled]="isDisabled(paymentType)"
      >
        <div class="radio-title">
          <span>{{ getPaymentTitle(paymentType) }}</span>
          @if(paymentType !== PaymentType.PAID_IN_CASH){
            <i class="fa-regular fa-circle-info" [matTooltip]='getPaymentHint(paymentType)'></i>
          }
        </div>
        <div class="description">{{ getPaymentDescription(paymentType) }}</div>
      </mat-radio-button>

      @if(paymentType === PaymentType.PAID_IN_CASH){
        <div class="generic-address-cont">
          <div class='address-toggle-header'>
            <div class="panel-title">
              {{ "APP.VOUCHERS.ADD_BILLING_ADDRESS" | translate }}
            </div>
            <div class='action' (click)='onShowAddress()'>
              @if(!showBillingAddress){
                <i class="fa-solid fa-circle-plus"></i>
              } @else {
                <i class="fa-solid fa-circle-minus"></i>
              }
            </div>
          </div>

          @if(showBillingAddress){
            <app-tax-invoice-details
              [form]="billingAddressForm"
              [appearance]="appearance"
              [showTitle]="false"
              [isGeneric]="true"
              [showCheckbox]='true'
              class="w-100"
            />
          }
        </div>
      }
    }
  </mat-radio-group>
</div>
